import { MessageSquare } from "lucide-react";

import { Button } from "./customDesignedComponents/button";
import { cn } from "../../lib/utils";
import {
  ensureCallPilotChatbotReady,
  openCallPilotChatbot,
} from "../helpers/callPilotChatbot";

type Props = {
  isSidebarOpen?: boolean;
  className?: string;
  variant?: "prominent" | "subtle";
};

const CallPilotChatButton = ({
  isSidebarOpen = true,
  className = "",
  variant = "prominent",
}: Props) => {
  const handleClick = () => {
    void ensureCallPilotChatbotReady({ hideLauncher: true }).then(() => {
      openCallPilotChatbot();
    });
  };

  if (variant === "subtle") {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={cn(
          "flex items-start gap-3 rounded-lg transition-colors w-full text-left",
          "text-muted-foreground hover:bg-muted hover:text-foreground",
          isSidebarOpen
            ? "px-3 py-2.5 text-sm font-medium min-w-0"
            : "px-0 py-2.5 justify-center",
          className,
        )}
      >
        <MessageSquare className="h-5 w-5 shrink-0 mt-0.5" />
        {isSidebarOpen ? (
          <span className="flex-1 min-w-0 whitespace-normal break-words leading-5">
            Ask a question
          </span>
        ) : null}
      </button>
    );
  }

  return (
    <Button
      type="button"
      variant="secondary"
      className={
        isSidebarOpen
          ? `w-full gap-2 rounded-full ${className}`.trim()
          : `w-10 h-10 p-0 gap-0 rounded-full ${className}`.trim()
      }
      onClick={handleClick}
    >
      <MessageSquare className="h-4 w-4" />
      {isSidebarOpen ? "ASK A QUESTION" : null}
    </Button>
  );
};

export default CallPilotChatButton;
